module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/plan_main_dream_center-fee63cd99841cbabbc0a40f8f2adad35.jpg";